export default __webpack_public_path__ + "static/media/zenyatta-discord.27155d73.mp3";